import { bookingsAPI } from 'api/bookingsAPI'
import { useQuery } from '@tanstack/react-query'

export default function useBookingById(bookingId?: number) {
  const query = useQuery({
    queryKey: ['bookingById', bookingId],
    queryFn: () => bookingsAPI.getBooking(bookingId),
    enabled: bookingId != null,
  })

  const response = query.data
  const booking = response

  return {
    booking,
    ...query,
  }
}
